import React, { ComponentPropsWithoutRef, ReactElement } from 'react';

export type RadioButtonProps = ComponentPropsWithoutRef<'input'> & {
  label?: string;
};

export function RadioButton({
  id,
  label,
  checked,
  ...rest
}: RadioButtonProps): ReactElement {
  return (
    <label htmlFor={id} className="radio">
      <input type="radio" checked={checked} {...rest} id={id} />
      <span className="radio__input" aria-checked={checked}></span>
      {label && <span className="radio__label">{label}</span>}
    </label>
  );
}
